module.exports = __webpack_public_path__ + "static/media/STAF_bokmål med lulesamisk_sentrert logo_neg(hvit).a1a8d356.svg";